module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "answer-count": _vm.answerCount,
      "amount": _vm.amount,
      "id": "progress"
    }
  }, [_c('div', {
    staticClass: "progress",
    style: ({
      width: _vm.progress + '%'
    })
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-321fe375"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressBar.vue
// module id = 142
// module chunks = 1